import React from "react"

import { AuthorizedsOfEmployment, EmploymentsOfPerson } from "../../../mtska-frontend-modules";

const WidgetAuthorizedsOfDriver = ({ editing, item, readonly }) => {
    if (!editing) readonly = true;

    return (
        <>
            {
                Array.isArray(item.employments) && item.employments.map((employment, k) => (
                    // se non ha un employment
                    <AuthorizedsOfEmployment
                        filters={employment}
                        key={k}
                    />
                ))
            }

            {

                (item.id && (!Array.isArray(item.employments) || item.employments.length == 0)) && (
                    // se non ha un employment
                    <EmploymentsOfPerson
                        filters={item}
                    />

                )
            }
        </>
    );


};


export default WidgetAuthorizedsOfDriver;
